module.exports = __webpack_public_path__ + "media/images/mailer/logo_sm_brand-0054aa225ef5f4f261786c7fc20ccac9.svg";